<template>
  <u-tooltip v-if="hasEllipsis && showTooltip" :title="text">
    <span :style="style" :class="className"> {{ shortText }}</span>
  </u-tooltip>
  <span v-if="!hasEllipsis" :style="style" :class="className">
    {{ shortText }}</span
  >
</template>

<script>
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'ShortText',
  inheritAttrs: true,
  props: {
    text: {
      type: String,
      default: ''
    },
    limit: {
      type: [Number, String],
      default: 8
    },
    showTooltip: {
      type: Boolean,
      default: true
    },
    style: {
      type: Object,
      default: () => ({})
    },
    className: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const realLimit = computed(() => {
      const zhArr = props.text.match(/[\u4e00-\u9fa5]/g) || [];
      const zhLen = zhArr.length;
      const originLen = props.text.length;
      const notCnLength = originLen - zhLen;
      return Math.round(notCnLength / 2) + zhLen;
    });
    const hasEllipsis = computed(() => {
      return realLimit.value > props.limit;
    });
    const shortText = computed(() => {
      let len = 0;
      let index = 0;
      const arr = [...props.text];
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        if (item.match(/[\u4e00-\u9fa5]/g)) {
          len += 1;
        } else {
          len += 0.5;
        }
        index = i;
        if (len >= props.limit) {
          break;
        }
      }
      if (hasEllipsis.value) {
        return `${arr.slice(0, index + 1).join('')}...`;
      }
      return props.text;
    });

    return {
      shortText,
      hasEllipsis
    };
  }
});
</script>
